require('webpack-jquery-ui/datepicker');
require('./pagination.coffee');

# Ответы на обращения
class window.Answers
  constructor: ->
    @curPage = 1 # текущая страница
    @searchForm = $('.answers-list__form') # форма поиска
    @searchNumber = $('.answers-list__form input[name="number"]') # номер документа для поиска
    @searchDate = $('.answers-list__form input[name="date"]') # дата документа для поиска
    @answersBlock = $('.answers-list__ajax') # блок со списокм результатов поиска
    @paginationBlock = $('.pagination_ajax') # блок с пагинацией 
    @initAnswersOpen()

  initAnswersOpen: ->
    self = this
    self.AnswersAjaxExec()
    $('.answers-list__form .js-data-picker').datepicker({
      closeText: "Закрыть",
      prevText: "Предыдущая",
      nextText: "Следующая",
      currentText: 'Сегодня',
      monthNames: ['Январь','Февраль','Март','Апрель','Май','Июнь','Июль','Август','Сентябрь','Октябрь','Ноябрь','Декабрь'],
      monthNamesShort: ['Янв','Фев','Мар','Апр','Май','Июн','Июл','Авг','Сен','Окт','Ноя','Дек'],
      dayNames: ['Воскресенье','Понедельник','Вторник','Среда','Четверг','Пятница','Суббота'],
      dayNamesShort: ['Вос','Пон','Вто','Сре','Чет','Пят','Суб'],
      dayNamesMin: ['Вс','Пн','Вт','Ср','Чт','Пт','Сб'],
      weekHeader: "Wk",
      dateFormat: "dd.mm.yy",
      firstDay: 1,
      isRTL: false,
      showMonthAfterYear: false,
      yearSuffix: ""
    });

    @searchForm.submit (event) ->
      event.preventDefault()
      @curPage = 1
      self.AnswersAjaxExec()

  AnswersAjaxExec: ->
    self = this
    resultList = ''
    $.ajax
      url: '/controllers/answers_list_ajax.php' # Путь до скрипта поиска
      data: {
        'number': $.trim(@searchNumber.val()),
        'date': $.trim(@searchDate.val()),
        'page': @curPage,
      }
      type: 'post'
      dataType: 'json'
      success: (result) ->
        if result.ITEMS
          $.each result.ITEMS, (key, value) ->
            resultList += '<div class="answers-list__title">' + value.NAME + '</div>';
            resultList += '<div class="answers-list__document-preview">';
            resultList += '<a href="' + value.FILE_LINK + '" target="_blank">' + value.FILE_NAME + '</a>';
            resultList += '<div class="link-download__file-weight">' + value.FILE_SIZE + '</div>';
            resultList += '</div>';
        else resultList = '<p>Ничего не найдено</p>'

        self.answersBlock.html(resultList) # Заполняем блок результатами

        self.paginationBlock.html(result.PAGINATION)
        window.paginationObject = new window.Pagination()
        
        return

  


// WEBPACK FOOTER //
// ./assets/javascripts/app/answers.coffee